import { render, staticRenderFns } from "./DispatchersReportTemplate.vue?vue&type=template&id=2227a08f"
import script from "./DispatchersReportTemplate.vue?vue&type=script&lang=js"
export * from "./DispatchersReportTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports